import { all } from "redux-saga/effects";
import { heSoLopTuNguyenSaga } from "./heSoLopTuNguyenSaga";
import { mauEmailSaga } from "./mauEmailSaga";

export default function* thietLapSagaWrapper() {
  yield all([heSoLopTuNguyenSaga(), mauEmailSaga()]);
}
